import { Button, HeaderContainer, Logo, LogoContainer, OptionsContainer, TopRow } from './Header.styles';
import { CloseIcon, FullScreenIcon } from '../../assets';
import { Fragment, FunctionalComponent, h } from 'preact';
import Heading from '../Heading';
import LanguageSelector from '../../components/LanguageSelector';
import { LogoCustomization } from '@usercentrics/cmp-browser-sdk';
import { VerticalSpacer } from '../Spacers/VerticalSpacer';
import { memo } from 'preact/compat';

type Props = {
  ariaLabel: string;
  closeAriaLabel: string;
  fullScreenAriaLabel: string;
  logoAlt?: string;
  logo: LogoCustomization;
  onClose?: () => void;
  onFullScreen?: () => void;
  onLanguageChange: (selectedLanguage: string) => void;
  showCloseButton?: boolean;
  showFullScreenButton?: boolean;
  showLanguage?: boolean;
  title: string;
};

const Header: FunctionalComponent<Props> = memo(
  ({
    ariaLabel,
    closeAriaLabel,
    children,
    fullScreenAriaLabel,
    logoAlt,
    logo: { position: logoPosition = 'left', url: logoUrl },
    onClose,
    onFullScreen,
    onLanguageChange,
    showCloseButton = false,
    showFullScreenButton,
    showLanguage = false,
    title,
  }) => (
    <HeaderContainer data-testid="uc-header" aria-label={ariaLabel}>
      {(logoUrl || showLanguage || showCloseButton || showFullScreenButton) && (
        <TopRow>
          <LogoContainer position={logoPosition}>
            {logoUrl && <Logo position={logoPosition} src={logoUrl} alt={logoAlt} />}
          </LogoContainer>
          <OptionsContainer position={logoPosition}>
            {showLanguage && <LanguageSelector onChange={onLanguageChange} />}
            {showCloseButton && (
              <Button aria-label={closeAriaLabel} height="28px" data-testid="uc-close-button" onClick={onClose}>
                <CloseIcon />
              </Button>
            )}
            {showFullScreenButton && (
              <Button
                aria-label={fullScreenAriaLabel}
                height="24px"
                data-testid="uc-fullscreen-button"
                onClick={onFullScreen}
              >
                <FullScreenIcon />
              </Button>
            )}
          </OptionsContainer>
        </TopRow>
      )}
      {logoUrl && <VerticalSpacer large />}
      {title && title !== '' && (
        <Fragment>
          <Heading>{title}</Heading>
          <VerticalSpacer small />
        </Fragment>
      )}
      {children}
    </HeaderContainer>
  ),
);

export default Header;
